<template>
  <div>
    <Dialog
      title="选择员工"
      :hide="dialogVisible"
      width="650px"
      @handleClick="changeClose"
      class="dialog-staff-box"
      style="position: relative;z-index:9999; !important"
    >
      <div slot="header">选择技师</div>
      <div slot="body">
        <div class="boxs">
          <div v-for="(item,index) in list" :key="index" class="box">
            <p
              :class="item.show?'active':''"
              @click="handleList(item,index)"
            >{{ item.staffName }}</p>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="flex flex-row">
          <div class="btns">
            <el-button class="btn" @click="cancel">取消</el-button>
            <el-button class="btn" type="primary" @click="confirm">确定添加</el-button>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import Dialog from "../../components/common/dialog.vue";
export default {
  data() {
    return {
      dialogVisible: false,
      staffId: null,
      form: {}
      // list: [],
      // query: {
      //     positionId: "",
      //     shopId: localStorage.getItem('shopIds')?localStorage.getItem('shopIds'):'',
      //     keyword: "",
      //     size: 20,
      //     start: 0,
      //     status: "enable"
      // },
      // url: this.$url.companyStaff.page,
      //合并行
    };
  },
  props: {
    isCashier: {
      typeof: Boolean,
      default: false 
    }
  },
  mixins: [minxin],
  components: { Dialog },
  created() {
    this.init();
  },
  mounted() {
    //this.getTableArr();
  },
  methods: {
    init() {
      this.$on("set", function(org) {
        this.staffId = org.index;
        this.form = org;
        if (org.shopId) {
          this.staffList(org.shopId);
        } else {
          this.staffList();
        }
      });
    },
    staffList(shopId) {
      let url = this.isCashier ? this.$url.companyShopStaff.listOnWork :this.$url.companyStaff.list
      console.log(shopId ? ("shopId: ", shopId) : "what...?");
      this.$api.get(url, {filterStatus: 'disable'}).then(res => {
        if (res.length) {
          this.dialogVisible = true;
          this.list = res;
          
          if (this.form.single) {
            for (let i in this.list) {
              if (this.list[i].id == this.form.staffIds) {
                this.$set(this.list[i], "show", true);
              } else {
                this.$set(this.list[i], "show", false);
              }
            }
          } else if (typeof(this.form.staffIds) == "string" && this.form.staffIds) {
            let arr = this.form.staffIds.split(",");
            for (let i in this.list) {
              let isTrue = false;
              for (let j in arr) {
                if (this.list[i].id == arr[j]) {
                  isTrue = true;
                  break;
                } else {
                  isTrue = false;
                }
              }
              if (isTrue) {
                this.$set(this.list[i], "show", true);
              } else {
                this.$set(this.list[i], "show", false);
              }
            }
          } else {
            for (let i in this.list) {
              let isTrue = false;
              for (let j in this.form.staffIds) {
                if (this.list[i].id == this.form.staffIds[j].staffId) {
                  isTrue = true;
                  break;
                } else {
                  isTrue = false;
                }
              }
              if (isTrue) {
                this.$set(this.list[i], "show", true);
              } else {
                this.$set(this.list[i], "show", false);
              }
            }
          }
        } else {
          this.$message("暂无打卡技师")
        }
          
        })
        .catch(error => {});
    },
    handleList(item, index) {
      if (this.form.single) {
        for (let i in this.list) {
          this.list[i].show = false;
        }
        this.list[index].show = true;
      } else {
        console.log(this.list);
        this.list[index].show
          ? (this.list[index].show = false)
          : (this.list[index].show = true);
      }
    },
    cancel() {
      this.dialogVisible = false;
    },
    confirm() {
      let obj = [];
      let isTypeOf = false;
      for (let i in this.list) {
        if (this.list[i].show) {
          if (this.list[i].id.indexOf("undefined") > -1) {
            isTypeOf = true;
          }
          obj.push({
            staffId: this.list[i].id,
            staffName: this.list[i].staffName
          });
        }
      }
      let arr = {
        nodeId: this.staffId,
        staffIds: obj
      };
      if (obj.length == 0) {
          return this.$message.error("请选择技师")
      }
      if (isTypeOf) {
        this.$message.error("员工参数错误，请重新选择");
        this.$emit("staffChange", '');
      } else {
        this.$emit("staffChange", arr);
      }
      this.dialogVisible = false;
    },
    changeClose(show) {
      this.dialogVisible = show;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/css/edit.less";

/deep/ .el-dialog {
  margin-top: 0 !important;
  height: 400px;
  top: calc(50% - 200px);
  border-radius: 10px;
  overflow-y:auto;
}

.dialog-staff-box {
  .boxs {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .box {
      display: flex;
      justify-content: center;
      p {
        width: 120px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        color: #333;
        margin-bottom: 25px;
        margin-left: 35px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        border: 1px solid #8d8d8d;
        border-radius: 6px;
        box-sizing: border-box;
      }
      .active {
        // background: url("../../assets/images/money/gou.png");
        // background-size: 100% 100%;
        border: 1px solid @blue;
        background: rgba(78, 137, 248, 0.1);
        color: #409eff;
      }
    }
  }
}
.dialog-footer {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 10px 20px;
  height: 70px;
  border: 0;
  box-sizing: border-box;
  .btn {
    width: 96px;
    height: 40px;
  }
}
</style>